'use client';

import { cn } from '@@/lib/utils';

import {
  Button,
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@@/ui/primitives';
import { Check, ChevronsUpDown } from 'lucide-react';
import { useState } from 'react';

const items = [
  { value: 'AGENT_REPLY', label: 'Agent Reply' },
  { value: 'API', label: 'API' },
  { value: 'CALLBACK', label: 'Callback' },
  { value: 'DISCONNECT', label: 'Disconnect' },
  { value: 'EXTERNAL_OUTBOUND', label: 'External Outbound' },
  { value: 'FLOW', label: 'Flow' },
  { value: 'INBOUND', label: 'Inbound' },
  { value: 'MONITOR', label: 'Monitor' },
  { value: 'OUTBOUND', label: 'Outbound' },
  { value: 'QUEUE_TRANSFER', label: 'Queue Transfer' },
  { value: 'TRANSFER', label: 'Transfer' },
  { value: 'WEBRTC_API', label: 'WebRTC API' }
];
export function FilterInitiationMethod(props: {
  disabled: boolean;
  selected: string[];
  onSelect: (value: string[]) => void;
}) {
  const [open, setOpen] = useState(false);

  const getDisplayText = () => {
    if (props.selected.length === 0) {
      return 'Choose';
    }
    if (props.selected.length === 1) {
      return items.find((item) => item.value === props.selected[0])?.label;
    }

    return `${props.selected.length} selected`;
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant='outline'
          role='combobox'
          aria-expanded={open}
          className='text-sm! justify-between'
          disabled={props.disabled}
        >
          {getDisplayText()}
          <ChevronsUpDown className='opacity-50' />
        </Button>
      </PopoverTrigger>
      <PopoverContent className='p-0 font-sans' align='start'>
        <Command>
          <CommandInput placeholder='Search initiation method...' className='text-sm!' />
          <CommandList>
            <CommandEmpty>No Initiation Method found.</CommandEmpty>
            <CommandGroup>
              {items.map((item) => {
                const isSelected = props.selected.includes(item.value);
                return (
                  <CommandItem
                    key={item.value}
                    value={item.value}
                    onSelect={() => {
                      const newSelected = isSelected
                        ? props.selected.filter((id) => id !== item.value)
                        : [...props.selected, item.value];
                      props.onSelect(newSelected);
                    }}
                    className='font-medium'
                  >
                    {item.label}
                    <Check
                      className={cn('ml-auto', props.selected.includes(item.value) ? 'opacity-100' : 'opacity-0')}
                    />
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
